import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { IdentityDocumentReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class IdentityDocumentReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/IdentityDocumentReference';
    private _identityDocumentTypeReference = new BehaviorSubject<IdentityDocumentReferenceModel[]>(null);

    get identityDocumentTypeReference() {
        return this._identityDocumentTypeReference.asObservable();
    }

    constructor(
        httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getIdentityDocumentReferences(): Observable<IdentityDocumentReferenceModel[]> {
        return this.httpGet<IdentityDocumentReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                tap(res => this._identityDocumentTypeReference.next(res.body)),
                map(res => res.body)
            )
    }
}